import api from "../api/api";

// The ONE existing public settings endpoint — GET /public-settings (no
// auth). Returns only { show_prices_to_guest }, never the full Setting
// object (that stays behind the existing admin_only /settings routes).
// The in-flight/successful request is shared, so the settings provider and the
// business-time helper (which both need this) cause ONE network call. A failed
// request is not cached, so the next caller retries.
let _publicSettings = null;
export function getPublicSettings() {
  if (!_publicSettings) {
    _publicSettings = api
      .get("/public-settings")
      .then((res) => res.data)
      .catch((err) => {
        _publicSettings = null;
        throw err;
      });
  }
  return _publicSettings;
}
